import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconStatusbarDownsampling = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 3.175 3.175",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		stroke: "currentColor",
		strokeWidth: .264,
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M.132.132h2.911v2.91H.133z" }),
			/* @__PURE__ */ _jsx("path", { d: "M.132 1.47h1.574v1.574H.132z" }),
			/* @__PURE__ */ _jsx("path", { d: "M.132 2.187h.856v.856H.132z" })
		]
	})
});
export default SvgIconStatusbarDownsampling;
